import { ICON_SIZE, MOTION } from "../../../theme/tokens";

/**
 * Shared look of the inline-edit pencil that `EditableCell` and `EditableSelectCell` draw in a
 * `SystemDataGrid` cell, so a text cell and a select cell advertise "editable" the same way.
 */

/** The pencil's glyph: the micro control size, so it sits beside body2 text without crowding it. */
export const EDITABLE_CELL_PENCIL_SIZE = ICON_SIZE.MICRO;

/**
 * Hidden at rest; revealed only while THIS grid cell is hovered or holds focus — never the whole row, so a
 * row of editable cells does not light up at once. Opacity only, so it is GPU-cheap and reduced-motion safe.
 */
export const EDITABLE_CELL_REVEAL_SX = {
	opacity: 0,
	transition: `opacity ${MOTION.DURATION.HOVER}ms ${MOTION.EASE_OUT}`,
	".MuiDataGrid-cell:hover &, .MuiDataGrid-cell:focus-within &": { opacity: 1 },
} as const;
